import classNames from "classnames";
import { FC } from "react";
import SvgError from "../icons/Error";
import SvgInfo from "../icons/Info";
import SvgWarning from "../icons/Warning";
import Icon from "./Icon";
import styles from "./MessageBox.module.css";

interface Props {
  text: string;
  type?: "warning" | "error";
}

const MessageBox: FC<Props> = ({ text, type }: Props) => (
  <span
    className={classNames(styles.text, {
      [styles.warning]: type == "warning",
      [styles.error]: type == "error",
    })}
  >
    <Icon glyph={type == "warning" ? SvgWarning : type == "error" ? SvgError : SvgInfo} className={styles.icon} />{" "}
    {text}
  </span>
);

export default MessageBox;
